import { toast } from 'react-toastify';
import CustomToast, {
  type CustomToastAction,
  type ToastType,
} from '@/shared/components/ui/CustomToast/CustomToast';

interface ShowToastProps {
  type: ToastType;
  title: string;
  message: string;
  actions?: CustomToastAction[];
}

export function showToast({ type, title, message, actions }: ShowToastProps) {
  toast(<CustomToast type={type} title={title} message={message} actions={actions} />, {
    icon: false,
    closeButton: false,
    hideProgressBar: true,
    className: '!bg-transparent !shadow-none !p-0',
    // Actions need to stay on screen until clicked, not auto-dismiss.
    autoClose: actions && actions.length > 0 ? false : undefined,
    // bodyClassName: '!p-0',
  });
}
